<template>
  <v-card id="watch-summary-card" class="py-4 px-5 my-0 elevation-0 full-height">
    <div
      class="watch-summary-card-header-title"
      :class="{
        'secondary--text': !$vuetify.theme.dark,
        'white--text': $vuetify.theme.dark,
      }"
    >
      {{ $t(`views.watchList.watchSummaryCard.${type}`) }}
      <!-- <InfoIcon v-if="infoText" :text="infoText" :size="14" /> -->
    </div>

    <div v-if="loadingSummary" class="bar-loading">
      <BarLoading hide-details />
    </div>
    <template v-else>
      <div class="watch-summary-card-value items-flex mt-1">
        <div
          class="watch-summary-card-value-number"
          :class="{
            'softGreen--text': value > 0,
            'secondary--text': value === 0,
            'softRed--text': value < 0,
          }"
        >
          <currency
            v-if="(value || value === 0)"
            neverHide
            :value="value"
            currency="%"
            :showPositive="true"
          />
          <span v-else>-</span>
        </div>
      </div>

      <div class="watch-summary-card-subtitle secondary--text">
        <!-- <strong>{{ subtitle }}</strong> -->
        <TableTicker v-if="summary && summary[type]" :position="summary[type]" notLinkToDetail />
      </div>
    </template>
  </v-card>
</template>

<script>
import { get } from 'lodash'
import Currency from '@/views/components/common/Currency'
import BarLoading from '@/views/components/core/BarLoading.vue'
// import InfoIcon from '@/views/components/common/InfoIcon'
import TableTicker from '@/views/components/common/TableTicker'

export default {
  components: {
    Currency,
    BarLoading,
    // InfoIcon,
    TableTicker,
  },
  props: {
    summary: {
      type: Object,
      default: () => {},
    },
    loadingSummary: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      required: true,
    },
  },
  computed: {
    value() {
      if (!this.summary || !this.summary[this.type]) return null

      if (this.type === 'firstByChangeP' || this.type === 'lastByChangeP')
        return get(this.summary[this.type], 'market.intraDay.changeP', null)
      else if (this.type === 'firstByBidPriceDistancePercent')
        return this.summary[this.type].bidPriceDistancePercent
      else if (this.type === 'firstByAskPriceDistancePercent')
        return this.summary[this.type].askPriceDistancePercent
      return null
    },
    subtitle() {
      if (!this.summary || !this.summary[this.type]) return ''

      let result = ''
      result += this.summary[this.type].ticker
      if (this.summary[this.type].name) result += ` (${this.summary[this.type].name})`
      return result
    },
    // infoText() {
    //   if (this.type === 'firstByChangeP')
    //     return 'Posición que más está cayendo durante el día de hoy'
    //   else if (this.type === 'lastByChangeP') return 'Posición que más está subiendo durante el día de hoy'
    //   else if (this.type === 'firstByBidPriceDistancePercent') return 'Más cerca del precio compra'
    //   else if (this.type === 'firstByAskPriceDistancePercent') return 'Más cerca del precio venta'
    //   return null
    // },
  },
}
</script>

<style lang="scss">
#watch-summary-card {
  .items-flex {
    display: flex;
    align-items: center;
    &.space-between {
      justify-content: space-between;
    }
  }
  &.full-height {
    height: 100%;
  }
  .watch-summary-card-header-title {
    font-size: 14px;
    font-weight: 500;
    i {
      margin-bottom: 1px;
    }
  }
  .watch-summary-card-value-number {
    font-size: 26px;
    font-weight: 600;
    font-family: Verdana, Geneva, Tahoma, sans-serif;
  }
  .watch-summary-card-subtitle {
    font-size: 14px;
    margin-top: 2px;
  }
}
</style>
